export enum LoginType {
  PROACTIVE = 'proactive',
  AUTOLOGIN = 'autologin',
}
